import { createContext } from "react";

const Th = createContext({});

export default Th;
